import React from "react";
import Hero from './MappingSurveying/Hero';
import MagicBento from './MappingSurveying/MagicBento';
import CertificationMumbaiChandigarh from "./CertificationMumbaiChandigarh";
import WhoCanApply from "./WhoCanApply";

const MappingSurveying = () => {

  return (
    <>
      <Hero />
      <WhoCanApply />
      <MagicBento />
      <CertificationMumbaiChandigarh />
    </>
  );
};

export default MappingSurveying;
